//管理整个项目中所有的数据请求

//引入二次封装后的axios
import requests from "./ajax"

//引入mockjs模拟的axios
// import mockRequests from './mockAjax'

//通过mock js 获取首页轮播图的数据
export const reqGetBannerList = () => mockRequests.get('/bannerList')


// //通过mock js 获取首页产品展示的数据
export const reqGetProductShow = () => mockRequests.get('/productShow') 

// //通过mock js 获取新闻页的数据
// export const reqGetNewsList = () => mockRequests.get('/newList')
// //通过mock js 获取行业动态的数据
// export const reqGetTrends = () => mockRequests.get('/trends')
// //通过mock js 获取新闻推荐的数据
// export const reqGetRecommendedNews = () => mockRequests.get('/recommendedNews')

// //通过mock js 获取产品第一分页的数据
// export const reqGetProductList1 = () => mockRequests.get('/productList1')
// //通过mock js 获取产品第二分页的数据
// export const reqGetProductList2 = () => mockRequests.get('/productList2')
// //通过mock js 获取产品第三分页的数据
// export const reqGetProductList3 = () => mockRequests.get('/productList3')
// //通过mock js 获取产品第四分页的数据
// export const reqGetProductList4 = () => mockRequests.get('/productList4')

//发送请求获取token
export const reqGetToken = () => requests({ url: "/manage/login", method: "POST", data: { "mobile": "web-zuofei", "password": "web-zuofei" } })
//将联系我们页面的用户数据发送到服务器
export const reqSendUserMsg = (params, headers) => requests({ url: "/manage/clue/create", method: "POST", data: params, headers: headers })








// 获取首页轮播
export const getHomeSliderList_url = (params) => requests({ url: "/api/actionApi/home/getHomeSliderList", method: "POST", data: params })


// 获取管线创新
export const getHomePipelineInnovationList_url = (params) => requests({ url: "/api/actionApi/home/getHomePipelineInnovationList", method: "POST", data: params })


// 获取首页企业优势列表
export const getHomeCorporateAdvantageList_url = (params) => requests({ url: "/api/actionApi/home/getHomeCorporateAdvantageList", method: "POST", data: params })

// 获取媒体报道列表-首页
export const getHomeTopMediaReportsList_url = (params) => requests({ url: "/api/actionApi/reports/getHomeTopMediaReportsList", method: "POST", data: params })

// 获取媒体报道列表-媒体报道
export const getMediaReportsList_url = (params) => requests({ url: "/api/actionApi/reports/getMediaReportsList", method: "POST", data: params })

export const getMediaReportsDetail_url = (params) => requests({ url: "/api/actionApi/reports/getMediaReportsDetail", method: "POST", data: params })
// 获取合作伙伴列表
export const getPartnerList_url = (params) => requests({ url: "/api/actionApi/partner/getPartnerList", method: "POST", data: params })

export const getCompanyInfo_url = (params) => requests({ url: "/api/actionApi/company/getCompanyInfo", method: "POST", data: params })

export const getCompanyTeamList_url = (params) => requests({ url: "/api/actionApi/company/getCompanyTeamList", method: "GET", params: params })

export const getDiseaseFieldList_url = (params) => requests({ url: "/api/actionApi/diseaseField/getDiseaseFieldList", method: "POST", data: params })

// 获取联系我们-职位列表
export const getJobsList_url = (params) => requests({ url: "/api/actionApi/jobs/getJobsList", method: "POST", data: params })

// 获取联系我们信息
export const getContactUsInfo_url = (params) => requests({ url: "/api/actionApi/contactUs/getContactUsInfo", method: "POST", data: params })

// 上传简历附件
export const uploadResume_url = (params) => requests({ url: "/api/actionApi/jobs/uploadResume", method: "POST", data: params })

// 获取职位详情
export const getJobsDetail_url = (params) => requests({ url: "/api/actionApi/jobs/getJobsDetail", method: "POST", data: params })
// 保存职位信息
export const saveJobsApplication_url = (params) => requests({ url: "/api/actionApi/jobs/saveJobsApplication", method: "POST", data: params })
// 获取地点以及部门
export const getDictList_url = (params) => requests({ url: "/api/actionApi/common/getDictList", method: "GET", params: params })
// 获取法律声明
export const getLegalNotice_url = (params) => requests({ url: "/api/actionApi/legalNotice/getLegalNotice", method: "POST", data: params })











// 英文版---------------------------------------------------------------------------------------------------------------------------------------------------
// 获取首页轮播
export const enGetHomeSliderList_url = (params) => requests({ url: "/enApi/actionApi/home/getHomeSliderList", method: "POST", data: params })


// 获取管线创新
export const enGetHomePipelineInnovationList_url = (params) => requests({ url: "/enApi/actionApi/home/getHomePipelineInnovationList", method: "POST", data: params })


// 获取首页企业优势列表
export const enGetHomeCorporateAdvantageList_url = (params) => requests({ url: "/enApi/actionApi/home/getHomeCorporateAdvantageList", method: "POST", data: params })

// 获取媒体报道列表-首页
export const enGetHomeTopMediaReportsList_url = (params) => requests({ url: "/enApi/actionApi/reports/getHomeTopMediaReportsList", method: "POST", data: params })

// 获取媒体报道列表-媒体报道enApi
export const enGetMediaReportsList_url = (params) => requests({ url: "/enApi/actionApi/reports/getMediaReportsList", method: "POST", data: params })

export const enGetMediaReportsDetail_url = (params) => requests({ url: "/enApi/actionApi/reports/getMediaReportsDetail", method: "POST", data: params })
// 获取合作伙伴列表
export const enGetPartnerList_url = (params) => requests({ url: "/enApi/actionApi/partner/getPartnerList", method: "POST", data: params })

export const enGetCompanyInfo_url = (params) => requests({ url: "/enApi/actionApi/company/getCompanyInfo", method: "POST", data: params })

export const enGetCompanyTeamList_url = (params) => requests({ url: "/enApi/actionApi/company/getCompanyTeamList", method: "GET", params: params })

export const enGetDiseaseFieldList_url = (params) => requests({ url: "/enApi/actionApi/diseaseField/getDiseaseFieldList", method: "POST", data: params })

// 获取联系我们-职位列表
export const enGetJobsList_url = (params) => requests({ url: "/enApi/actionApi/jobs/getJobsList", method: "POST", data: params })

// 获取联系我们信息
export const enGetContactUsInfo_url = (params) => requests({ url: "/enApi/actionApi/contactUs/getContactUsInfo", method: "POST", data: params })

// 上传简历附件
export const enUploadResume_url = (params) => requests({ url: "/enApi/actionApi/jobs/uploadResume", method: "POST", data: params })

// 获取职位详情
export const enGetJobsDetail_url = (params) => requests({ url: "/enApi/actionApi/jobs/getJobsDetail", method: "POST", data: params })
// 保存职位信息
export const enSaveJobsApplication_url = (params) => requests({ url: "/enApi/actionApi/jobs/saveJobsApplication", method: "POST", data: params })
// 获取地点以及部门
export const enGetDictList_url = (params) => requests({ url: "/enApi/actionApi/common/getDictList", method: "GET", params: params })
// 获取法律声明
export const enGetLegalNotice_url = (params) => requests({ url: "/enApi/actionApi/legalNotice/getLegalNotice", method: "POST", data: params })






// /api/actionApi/legalNotice/getLegalNotice